__webpack_require__.p = "/acquisition-offer-contracts-adjustment/system-email-templates/";